/**
 * da-variant-gallery-v2.js — Dev Aastha
 * ===========================================================================
 * Selected variant ke hisaab se PDP gallery filter karti hai (main slides,
 * desktop rail, zoom dialog) aur us variant ki #dim wali image pehle laati hai.
 *
 * SWIPER KA MAALIK YE FILE NAHI HAI. Nayi Swiper NAHI banati, destroy NAHI karti,
 * .swiper-wrapper ke transform ko haath NAHI lagati.
 *
 * ===========================================================================
 * PDP V2 KA APNA PICKER — ye jaanna zaroori hai
 * ===========================================================================
 * Is theme me Ella ke <variant-selects> CSS se CHHUPE hue hain (clip-path:inset(50%))
 * aur uski jagah PDP V2 ka apna picker dikhta hai:
 *   <button class="vopt" data-da-vopt data-option="Size" data-value="8 inch"
 *           aria-current="true">
 * Isliye sirf 'variant-selects' par bharosa karna kaafi nahi — hum [data-da-vopt]
 * ko bhi padhte hain aur usi par click bhi sunte hain.
 *
 * MULTI-OPTION VARIANTS: "Silver / 8 inch" ka tag #silver-8-inch hota hai, jiska
 * norm "silver8inch" banta hai. Alag-alag picker values ("silver", "8inch") isse
 * match nahi karti — isliye hum selected values ko JODKAR bhi token banate hain.
 * Pehle ye token sirf variant TITLE se banta tha, jo input[name="id"] par depend
 * karta hai; Ella wo async update karta hai, isliye click par purana variant milta
 * tha aur chart chhupa reh jaata tha (refresh par sahi aata tha).
 *
 * HERO IMAGE: agar Swiper abhi initialise nahi hua (Ella deferUntilInteraction +
 * Motion.inView ka intezaar karta hai) to slideTo() kuch nahi karta aur hero wahi
 * purani image rehti hai. Us haalat me hum Ella ka apna setActiveMedia() bulate
 * hain — wo slideshow aur thumbnails dono sync kar deta hai.
 *
 * ALT-TEXT TAG FORMAT:  <SEO alt text> #common | #<variant-slug> | #dim
 * ACTIVATION: product par tag `variant-images-on`.
 * ===========================================================================
 */
(function () {
  'use strict';

  var CONFIG = {
    productTag: 'variant-images-on',
    runOnAllProducts: false,
    bootDelay: 300,
    reorder: true,
    dipMs: 360, settleMs: 160,
    dipOpacity: 0.55, dipBlur: 5, dipScale: 0.985, sheenAlpha: 0.45,
    debug: false
  };
  if (window.DA_VG2) for (var k in window.DA_VG2) if (Object.prototype.hasOwnProperty.call(window.DA_VG2, k)) CONFIG[k] = window.DA_VG2[k];

  var HIDDEN = 'da-vg2-hidden';
  var COMMON = 'common';
  var DIM = 'dim';
  var PICKERS = 'variant-selects, variant-picker, [data-da-vpicker]';
  var state = { product: null, enabled: false, gallery: null, entries: [], tokens: [] };

  function log() { if (CONFIG.debug && window.console) console.log.apply(console, ['[da-vg2]'].concat([].slice.call(arguments))); }
  function norm(v) { return String(v == null ? '' : v).toLowerCase().replace(/[^a-z0-9]+/g, ''); }
  function reducedMotion() { return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); }

  function productHandle() {
    var m = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }
  function loadProduct() {
    var h = productHandle();
    if (!h) return Promise.resolve(null);
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root.replace(/\/$/, '') + '/products/' + h + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
  }

  var TAG_RE = /#([a-z0-9][a-z0-9._-]*)/gi;
  function readTags(alt) {
    var out = [], m; TAG_RE.lastIndex = 0;
    while ((m = TAG_RE.exec(alt || '')) !== null) { var t = norm(m[1]); if (t) out.push(t); }
    return out;
  }
  function stripTags(alt) {
    return String(alt || '').replace(/\s*#[a-z0-9][a-z0-9._-]*/gi, '').replace(/\s{2,}/g, ' ').trim();
  }
  function rawAlt(img) {
    var kept = img.getAttribute('data-da-alt');
    if (kept !== null) return kept;
    var a = img.getAttribute('alt') || '';
    if (a.indexOf('#') === -1) return a;
    img.setAttribute('data-da-alt', a);
    img.setAttribute('alt', stripTags(a));
    return a;
  }

  function currentVariant() {
    var input = document.querySelector('input[name="id"]');
    var id = input ? String(input.value) : null;
    if (state.product && id) {
      for (var i = 0; i < state.product.variants.length; i++) {
        if (String(state.product.variants[i].id) === id) return state.product.variants[i];
      }
    }
    return null;
  }

  /* Selected option values — PDP V2 ke custom picker se AUR Ella ke chhupe hue
     radios/selects se, dono se. Position order me rakhne ki koshish. */
  function pickerValues() {
    var seen = {}, list = [];
    var add = function (v, pos) {
      v = String(v == null ? '' : v).trim();
      if (!v || norm(v) === 'defaulttitle') return;
      var key = norm(v); if (seen[key]) return;
      seen[key] = 1; list.push({ v: v, pos: isFinite(pos) ? +pos : 99 });
    };
    Array.prototype.forEach.call(document.querySelectorAll('[data-da-vopt][aria-current="true"]'), function (b) {
      add(b.getAttribute('data-value'), b.getAttribute('data-position'));
    });
    Array.prototype.forEach.call(document.querySelectorAll(
      'variant-selects input[type="radio"]:checked, variant-selects select, variant-picker input[type="radio"]:checked, variant-picker select'
    ), function (el, i) { add(el.value, el.getAttribute('data-position') || (i + 1)); });
    list.sort(function (a, b) { return a.pos - b.pos; });
    return list.map(function (x) { return x.v; });
  }

  function activeTokens() {
    var out = [];
    var push = function (v) { var n = norm(v); if (n && n !== 'defaulttitle' && out.indexOf(n) === -1) out.push(n); };
    var vals = pickerValues();
    vals.forEach(push);
    if (vals.length > 1) {
      push(vals.join(' '));
      push(vals.join('/'));
      push(vals.slice().reverse().join(' '));
    }
    var v = currentVariant();
    if (v) { (v.options || []).forEach(push); push(v.title); }
    return out;
  }

  function matches(tags) {
    if (!tags.length) return true;
    if (tags.indexOf(COMMON) !== -1) return true;
    for (var i = 0; i < tags.length; i++) if (state.tokens.indexOf(tags[i]) !== -1) return true;
    return false;
  }

  function injectStyle() {
    if (document.getElementById('da-vg2-style')) return;
    var s = document.createElement('style'); s.id = 'da-vg2-style';
    var ease = 'cubic-bezier(.4,0,.2,1)';
    s.textContent =
      '.' + HIDDEN + '{display:none !important;}' +
      'media-gallery{position:relative;}' +
      'media-gallery .swiper{will-change:opacity,transform,filter;overflow:hidden;' +
        'transition:opacity ' + CONFIG.dipMs + 'ms ' + ease + ',transform 460ms cubic-bezier(.22,1,.36,1)' +
        ',filter ' + CONFIG.dipMs + 'ms ' + ease + ';}' +
      'media-gallery.da-vg2-dip .swiper{opacity:' + CONFIG.dipOpacity + ';' +
        'transform:scale(' + CONFIG.dipScale + ');filter:blur(' + CONFIG.dipBlur + 'px);}' +
      'media-gallery::after{content:"";position:absolute;inset:0;pointer-events:none;opacity:0;z-index:4;overflow:hidden;' +
        'background:linear-gradient(105deg,transparent 38%,rgba(255,255,255,' + CONFIG.sheenAlpha + ') 50%,transparent 62%);}' +
      'media-gallery.da-vg2-sheen::after{animation:daVg2Sheen .7s ' + ease + ';}' +
      '@keyframes daVg2Sheen{from{opacity:1;transform:translateX(-45%)}to{opacity:0;transform:translateX(45%)}}' +
      '.da-gal-rail.da-vg2-stagger button{animation:daVg2Thumb .36s cubic-bezier(.22,1,.36,1) both;' +
        'animation-delay:calc(var(--i,0) * 38ms);}' +
      '@keyframes daVg2Thumb{from{opacity:0;transform:translateY(7px) scale(.94)}to{opacity:1;transform:none}}' +
      '@media (prefers-reduced-motion:reduce){media-gallery .swiper{transition:none!important;}' +
        'media-gallery.da-vg2-dip .swiper{opacity:1!important;filter:none!important;transform:none!important;}' +
        'media-gallery.da-vg2-sheen::after{animation:none!important;}' +
        '.da-gal-rail.da-vg2-stagger button{animation:none!important;}}';
    (document.head || document.documentElement).appendChild(s);
  }

  var fading = false;
  function withFade(gallery, work, settle) {
    if (reducedMotion() || fading) { work(); if (settle) settle(); return; }
    fading = true;
    gallery.classList.add('da-vg2-dip');
    setTimeout(function () {
      try { work(); } catch (e) {}
      setTimeout(function () {
        try { if (settle) settle(); } catch (e) {}
        requestAnimationFrame(function () {
          gallery.classList.remove('da-vg2-dip');
          gallery.classList.add('da-vg2-sheen');
          var rail = document.querySelector('.da-gal-rail');
          if (rail) { rail.classList.remove('da-vg2-stagger'); void rail.offsetWidth; rail.classList.add('da-vg2-stagger'); }
          setTimeout(function () {
            gallery.classList.remove('da-vg2-sheen');
            if (rail) rail.classList.remove('da-vg2-stagger');
            fading = false;
          }, 800);
        });
      }, CONFIG.settleMs);
    }, CONFIG.dipMs);
  }

  function slideOf(el) {
    return el.closest('.swiper-slide') || el.closest('.product-media-container') || el.closest('li') || el;
  }
  function readEntries(gallery) {
    var out = [], seen = {};
    Array.prototype.forEach.call(gallery.querySelectorAll('[data-media-id]'), function (el) {
      var id = el.getAttribute('data-media-id');
      if (!id || seen[id]) return; seen[id] = 1;
      var img = el.querySelector('img');
      var tags = readTags(img ? rawAlt(img) : '');
      out.push({ id: String(id), tags: tags.filter(function (t) { return t !== DIM; }),
                 dim: tags.indexOf(DIM) !== -1, slide: slideOf(el) });
    });
    return out;
  }

  function ITEM(el) {
    return el.closest('.dialog-thumbnails-list__thumbnail') || el.closest('[data-zoom-index]') ||
           el.closest('.swiper-slide') || el.closest('.product-media-container') || el.closest('li') || el;
  }
  function filterEverywhere() {
    Array.prototype.forEach.call(document.querySelectorAll('img[alt], img[data-da-alt]'), function (img) {
      if (img.closest('.da-gal-rail')) return;
      var raw = img.getAttribute('data-da-alt');
      if (raw === null) {
        raw = img.getAttribute('alt') || '';
        if (raw.indexOf('#') === -1) return;
        img.setAttribute('data-da-alt', raw);
        img.setAttribute('alt', stripTags(raw));
      }
      var tags = readTags(raw).filter(function (t) { return t !== DIM; });
      if (!tags.length) return;
      var item = ITEM(img);
      if (item) item.classList.toggle(HIDDEN, !matches(tags));
    });
  }

  function getSwiper() {
    var el = document.querySelector('media-gallery .swiper');
    if (el && el.swiper) return el.swiper;
    var comp = document.querySelector('media-gallery swiper-component');
    if (comp && comp.initSwiper) return comp.initSwiper;
    return null;
  }

  function reorderSlides(gallery) {
    if (!CONFIG.reorder) return false;
    var wrap = gallery.querySelector('.swiper-wrapper');
    if (!wrap) return false;
    var visible = state.entries.filter(function (e) {
      return e.slide && !e.slide.classList.contains(HIDDEN) && e.slide.parentNode === wrap;
    });
    if (visible.length < 2) return false;
    var spec = visible.filter(function (e) { return e.tags.length && e.tags.indexOf(COMMON) === -1; });
    var comm = visible.filter(function (e) { return spec.indexOf(e) === -1; });
    spec.sort(function (a, b) { return (b.dim ? 1 : 0) - (a.dim ? 1 : 0); });
    var want = spec.concat(comm);
    if (want.every(function (e, i) { return visible[i] === e; })) return false;
    var frag = document.createDocumentFragment();
    want.forEach(function (e) { frag.appendChild(e.slide); });
    state.entries.forEach(function (e) {
      if (want.indexOf(e) === -1 && e.slide && e.slide.parentNode === wrap) frag.appendChild(e.slide);
    });
    wrap.appendChild(frag);
    return true;
  }

  function rebuildRail() {
    var rail = document.querySelector('.da-gal-rail');
    var main = document.querySelector('.product-information__media .swiper-main');
    if (!rail || !main) return;
    var visible = [].slice.call(main.querySelectorAll('.swiper-slide')).filter(function (s) {
      return !s.classList.contains(HIDDEN);
    });
    if (!visible.length) return;
    while (rail.firstChild) rail.removeChild(rail.firstChild);
    visible.forEach(function (slide, i) {
      var img = slide.querySelector('img'); if (!img) return;
      var b = document.createElement('button');
      b.type = 'button'; b.setAttribute('aria-label', 'Image ' + (i + 1));
      b.dataset.daIdx = String(i); b.style.setProperty('--i', String(i));
      var t = document.createElement('img');
      t.src = (img.getAttribute('src') || '').replace(/([?&])width=\d+/, '$1width=160');
      t.alt = ''; t.loading = 'lazy'; t.decoding = 'async';
      b.appendChild(t);
      b.addEventListener('click', function () {
        var sw = main.swiper;
        var idx = [].slice.call(main.querySelectorAll('.swiper-slide')).indexOf(slide);
        if (sw && typeof sw.slideTo === 'function') sw.slideTo(idx < 0 ? i : idx);
        else { try { slide.scrollIntoView({ block: 'nearest', inline: 'start' }); } catch (e) {} }
        Array.prototype.forEach.call(rail.children, function (x, n) {
          if (n === i) x.setAttribute('aria-current', 'true'); else x.removeAttribute('aria-current');
        });
      });
      rail.appendChild(b);
    });
    if (rail.firstChild) rail.firstChild.setAttribute('aria-current', 'true');
  }

  function firstVisible() {
    var main = document.querySelector('media-gallery .swiper') || state.gallery;
    if (!main) return null;
    var all = [].slice.call(main.querySelectorAll('.swiper-slide'));
    for (var i = 0; i < all.length; i++) {
      if (!all[i].classList.contains(HIDDEN)) {
        var el = all[i].querySelector('[data-media-id]') || all[i];
        return { index: i, id: el.getAttribute && el.getAttribute('data-media-id') };
      }
    }
    return null;
  }

  /* Hero ko pehli visible image par le jao.
     Swiper ho to slideTo, warna Ella ka apna setActiveMedia() — wo slideshow aur
     thumbnails dono sync karta hai aur init ka intezaar khud kar leta hai. */
  function goFirst() {
    var fv = firstVisible(); if (!fv) return;
    var sw = getSwiper();
    if (sw) { try { sw.update(); sw.slideTo(fv.index, 0); } catch (e) {} }
    if (fv.id && state.gallery && typeof state.gallery.setActiveMedia === 'function') {
      try { state.gallery.setActiveMedia(String(fv.id), false); } catch (e) {}
    }
  }

  function applyNow() { filterEverywhere(); reorderSlides(state.gallery); rebuildRail(); goFirst(); }

  function refresh(animated) {
    if (!state.enabled || !state.gallery) return;
    var run = function () {
      state.tokens = activeTokens();
      if (!state.tokens.length) return;
      if (!state.entries.filter(function (e) { return matches(e.tags); }).length) {
        Array.prototype.forEach.call(document.querySelectorAll('.' + HIDDEN), function (x) { x.classList.remove(HIDDEN); });
        return;
      }
      applyNow();
    };
    var settle = function () {
      var before = state.tokens.join('|');
      var now = activeTokens();
      if (now.length && now.join('|') !== before) {
        state.tokens = now;
        if (state.entries.filter(function (e) { return matches(e.tags); }).length) applyNow();
      } else { goFirst(); }
    };
    if (animated) withFade(state.gallery, run, settle); else { run(); }
  }

  function boot() {
    state.gallery = document.querySelector('media-gallery');
    if (!state.gallery) return;
    injectStyle();
    state.entries = readEntries(state.gallery);
    refresh(false);

    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      if (getSwiper() || document.querySelector('.da-gal-rail')) { clearInterval(iv); refresh(false); }
      else if (tries > 40) clearInterval(iv);
    }, 500);

    document.addEventListener('variant:update', function () { refresh(true); });
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest(PICKERS)) refresh(true);
    });
    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      /* PDP V2 ka apna picker — do baar: turant, aur aria-current set hone ke baad */
      if (e.target.closest('[data-da-vopt]') || e.target.closest(PICKERS)) {
        setTimeout(function () { refresh(true); }, 0);
        setTimeout(function () { if (!fading) refresh(true); }, 260);
        return;
      }
      if (e.target.closest('media-gallery')) {
        setTimeout(function () { if (state.tokens.length) filterEverywhere(); }, 120);
        setTimeout(function () { if (state.tokens.length) filterEverywhere(); }, 500);
      }
    }, true);
  }

  function start() {
    if (!productHandle()) return;
    if (!document.querySelector('media-gallery')) return;
    loadProduct().then(function (p) {
      state.product = p;
      var tags = (p && p.tags) || [];
      state.enabled = tags.some(function (t) { return norm(t) === norm(CONFIG.productTag); });
      if (!state.enabled && !CONFIG.runOnAllProducts) { log('not enabled'); return; }
      if (document.readyState === 'complete') setTimeout(boot, CONFIG.bootDelay);
      else window.addEventListener('load', function () { setTimeout(boot, CONFIG.bootDelay); }, { once: true });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
